const PERSISTABLE_KEYS = new Set([
  'organizations',
  'projects',
  'tasks',
  'contacts',
  'members',
  'entities',
  'invoices',
  'products',
  // Time entry lists/totals change across browser, desktop, and realtime flows.
  // Do not persist them; stale hours are worse than a loading state.
  'contracts',
  'client-portal',
  // Table modules — restored instantly so lists render from cache on revisit
  'leads',
  'deals',
  'notes',
  'documents',
  'forms',
  'suppliers',
  'tickets',
  'events',
  'custom-collections',
  'sprints',
  'cycles',
  // Column metadata — these gate table column building; persisting them means
  // tables skip the skeleton and render with the correct columns immediately
  'custom-fields',
  'column-preferences',
  'crm-stages',
  // My Work primary data — without these a reload always cold-fetches the
  // 500-row task list and assigned tickets before first paint
  'my-tasks',
  'my-work',
  'ticket-types',
])

export function shouldPersistQuery(queryKey: readonly unknown[]): boolean {
  const root = queryKey[0]
  if (typeof root !== 'string') return false
  return PERSISTABLE_KEYS.has(root)
}
